import React, { forwardRef, useMemo } from 'react'
import cx from 'classnames'
import { Icon, Link, sanitizeURL } from '@manychat/manyui'

import { mapTextToContentArray } from './lib/mapTextToContentArray'

import cm from './styles.module.css'

export enum MessageType {
  RECEIVED = 'RECEIVED',
  SENT = 'SENT',
}

interface MessageBubbleProps {
  type: MessageType
  text: string
  isDimmed?: boolean
  children?: React.ReactNode
}

export const MessageBubble = forwardRef<HTMLLIElement, MessageBubbleProps>(
  ({ type, text, isDimmed, children }: MessageBubbleProps, ref) => {
    const result = useMemo(() => mapTextToContentArray(text), [text])

    const isReceived = type === MessageType.RECEIVED

    return (
      <li
        ref={ref}
        className={cx(cm.wrapper, {
          [cm.received]: isReceived,
          [cm.sent]: !isReceived,
          [cm.dimmed]: isDimmed,
        })}
      >
        {isReceived && (
          <div className={cm.avatar} aria-hidden>
            <Icon.Ai size={20} />
          </div>
        )}

        <div className={cm.content}>
          <p className={cm.text}>
            {result.map((chunk, index) => {
              if (chunk.type === 'link') {
                return (
                  <Link
                    key={index}
                    className={cm.link}
                    href={sanitizeURL(chunk.content)}
                    target="_blank"
                  >
                    {chunk.content}
                  </Link>
                )
              }

              return <span key={index}>{chunk.content}</span>
            })}
          </p>
          {children}
        </div>

        <div className={cm.spacer} />
      </li>
    )
  },
)
